import React from 'react'
import { ListGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { setLanguageS } from '../../store/modules/language';

export default function Languageitem() {
  const {lg}=useSelector((state)=>state.language);
  const dispatch=useDispatch();
  const handleItemClick = (str) => {
    dispatch(setLanguageS(str));
    localStorage.setItem('language',str);
  };

  return (
    <ListGroup variant="flush">
      <ListGroup.Item action
        className='py-3' active={lg==='zh'}
        onClick={() => { handleItemClick('zh') }}
      >
        简体中文
      </ListGroup.Item>
      <ListGroup.Item action
        className='py-3' active={lg==='ft'}
        onClick={() => { handleItemClick('ft') }}
      >
        繁體中文
      </ListGroup.Item>
      <ListGroup.Item action
        className='py-3' active={lg==='en'}
        onClick={() => { handleItemClick('en') }}
      >
        English
      </ListGroup.Item>
      <ListGroup.Item action
        className='py-3' active={lg==='ja'}
        onClick={() => { handleItemClick('ja') }}
      >
        日本語
      </ListGroup.Item>
    </ListGroup>
  )
};

